import { isMockServices } from 'src/utils';
import mock from 'src/services/utils/mock';
import { QueryFunction } from '@tanstack/react-query';
import { getCompatibleAuthTokenHttp } from '../utils/enhancedAuthTokenHttp';
import { TaskResponse, SearchTasksParams } from './types';

/** Fetch tasks by search params; can be used outside React Query (e.g. CSV export). */
export async function fetchTasksSearch(
  params: SearchTasksParams,
): Promise<TaskResponse> {
  if (isMockServices()) return await mock(getSearchTasksMockData());

  const queryParams = new URLSearchParams();
  if (params.loanNumber?.trim())
    queryParams.append('loanNumber', params.loanNumber.trim());
  if (params.serviceName?.length)
    params.serviceName.forEach((t) => queryParams.append('serviceName', t));
  if (params.cursor) queryParams.append('cursor', params.cursor);
  if (params.limit != null) queryParams.append('limit', String(params.limit));
  if (params.status) queryParams.append('status', params.status);
  if (params.dateFrom) queryParams.append('dateFrom', params.dateFrom);
  if (params.dateTo) queryParams.append('dateTo', params.dateTo);

  const authTokenHttp = await getCompatibleAuthTokenHttp();
  const response = await authTokenHttp<TaskResponse>(
    `/tasks/search?${queryParams.toString()}`,
    { method: 'GET' },
  );

  if (response.data)
    return {
      tasks: response.data.tasks ?? [],
      nextCursor: response.data.nextCursor ?? null,
    };
  throw new Error('Failed to fetch tasks');
}

const searchTasks: QueryFunction<
  TaskResponse,
  ['/tasks/search', SearchTasksParams]
> = async ({ queryKey }) => {
  const [, params] = queryKey;
  return fetchTasksSearch(params);
};

export default searchTasks;

function getSearchTasksMockData(): TaskResponse {
  return {
    tasks: [
      {
        loanId: crypto.randomUUID(),
        taskId: crypto.randomUUID(),
        taskType: 'recognizer',
        taskStatus: 'completed',
        fileName: 'document.pdf',
        taskStartedDatetime: new Date().toISOString(),
        taskCompletedDatetime: new Date().toISOString(),
      },
      {
        loanId: crypto.randomUUID(),
        taskId: crypto.randomUUID(),
        taskType: 'converter',
        taskStatus: 'completed',
        fileName: 'document.pdf',
        taskStartedDatetime: new Date().toISOString(),
        taskCompletedDatetime: new Date().toISOString(),
      },
    ],
    nextCursor: null,
  };
}
